import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { uiTheme as t } from './theme';

interface IconBadgeProps {
  /** Icono a mostrar (normalmente un icono de `@mui/icons-material`). */
  icon: ReactNode;
  /** Color de fondo del cuadro. */
  bg?: string;
  /** Color del icono. */
  color?: string;
}

const Box = styled.div<{ bg: string; iconColor: string }>(({ bg, iconColor }) => ({
  width: 50,
  height: 50,
  flex: 'none',
  borderRadius: t.radius.md,
  background: bg,
  color: iconColor,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& .MuiSvgIcon-root': { fontSize: 27 },
}));

/**
 * Primitivo: cuadro de color redondeado que envuelve un icono. Da identidad
 * visual a cada sección sin acoplarse al icono concreto que reciba.
 */
const IconBadge = ({ icon, bg = t.color.countBg, color = t.color.primary }: IconBadgeProps) => (
  <Box bg={bg} iconColor={color}>
    {icon}
  </Box>
);

export default IconBadge;
